import React from 'react';

export const Shape1 = (props) => (
  <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M75 150C75 108.579 108.579 75 150 75V0C67.1573 0 0 67.1573 0 150H75Z" />
  </svg>
);

export const Shape3 = (props) => (
  <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0V75C191.421 75 225 108.579 225 150C225 191.421 191.421 225 150 225C108.579 225 75 191.421 75 150H0C0 232.843 67.1573 300 150 300Z" />
  </svg>
);

export const ShapeRectangle = (props) => (
  <svg width="75" height="225" viewBox="0 0 75 225" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="75" height="225" transform="matrix(1 0 0 -1 0 225)" />
  </svg>
);
